
/**
 * エントリーページ ファイル選択
 */
export class FileSelect {

  /**
   * fn-fileselect
   */
  private m_element: JQuery;

  /**
   * コンストラクタ
   */
  constructor(element: string) {
    this.m_element = $(element);

    if (! this.m_element[0]) {
      return;
    }

    this.PrintFileName();
  }

  /**
   * メンバ関数
   */
  private PrintFileName() {
    // DOM生成
    this.m_element.after('<div class="fileButton"><label for="file">ファイル選択</label></div>');
    this.m_element.after('<span class="fileName" >選択されていません</span>');
    // ファイル名が変更された
    this.m_element.on('change',() => {
      // files属性取得
      var file = this.m_element.prop('files')[0];
      // fileName挿入
      $('.fileName').html(file.name);
    });
  }

}
